<template>
  <picture :class="[fullSize && 'full-size']">
    <template v-for="(srcset, index) in srcsets" :key="index">
      <source
        v-if="index + 1 < srcsets.length"
        :srcset="
          (getSrcset(srcset).startsWith('http') && getSrcset(srcset)) ||
            basePath + getSrcset(srcset)
        "
        :media="srcset.media"
      />
      <template v-else>
        <a
          v-if="linked != undefined"
          :href="linked || basePath + getSrcset(srcset)"
          :target="linked && linked.startsWith('http') && '_blank'"
        >
          <img
            :class="[
              objectFit && `objectfit-${objectFit}`,
              thumbnail && 'thumbnail'
            ]"
            :src="
              (getSrcset(srcset).startsWith('http') && getSrcset(srcset)) ||
                basePath + getSrcset(srcset)
            "
            :alt="alt || title"
            :title="title"
            :onerror="onerror"
          />
        </a>
        <img
          v-else
          :class="[
            objectFit && `objectfit-${objectFit}`,
            thumbnail && 'thumbnail'
          ]"
          :src="
            (getSrcset(srcset).startsWith('http') && getSrcset(srcset)) ||
              basePath + getSrcset(srcset)
          "
          :alt="alt || title"
          :title="title"
          :onerror="onerror"
        />
      </template>
    </template>
  </picture>
</template>
<script>
export default {
  props: {
    srcsets: {
      type: Array,
      required: true
    },
    src: {
      type: String
    },
    alt: {
      type: String
    },
    title: {
      type: String,
      required: true
    },
    thumbnail: {
      type: Boolean,
      default: false
    },
    fullSize: {
      type: Boolean,
      default: false
    },
    linked: {
      type: String
    },
    objectFit: {
      type: String,
      default: "cover",
      validator(value) {
        const values = ["cover", "contain", "fill", "scale-down", "none"];
        return values.includes(value);
      }
    },
    onerror: {
      type: String,
      default: () =>
        `this.onerror=null;this.src='${process.env.VUE_APP_PUBLIC_PATH}/images/unavailable.svg'`
    }
  },
  setup() {
    const basePath = process.env.VUE_APP_PUBLIC_PATH;
    const getSrcset = srcset => {
      return typeof srcset === "string" || srcset instanceof String
        ? srcset
        : srcset.source;
    };
    return {
      basePath,
      getSrcset
    };
  }
};
</script>
<style lang="scss" scoped>
picture {
  height: 100%;
  &.full-size {
    width: 100%;
  }
  img {
    width: 100%;
    height: 100%;
    &.objectfit-cover {
      object-fit: cover;
    }
    &.objectfit-contain {
      object-fit: contain;
    }
    &.objectfit-fill {
      object-fit: fill;
    }
    &.objectfit-scale-down {
      object-fit: scale-down;
    }
    &.objectfit-none {
      object-fit: none;
    }
  }
}
</style>
